import { QueryClient } from 'react-query';
import REACT_CONFIG from 'REACT_CONFIG';

export default new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
      cacheTime: REACT_CONFIG.REACT_APP_QUERY_CLIENT_CACHE_LIFETIME,
    },
  },
});
